import { PlayCircle, Download } from "lucide-react";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { API } from "@/utils/constants";

export default function TutorialView() {
  return (
    <div className="p-4 sm:p-6 max-w-4xl mx-auto" data-testid="tutorial-view">
      <div className="rounded-2xl overflow-hidden border shadow-lg bg-black">
        <video controls preload="metadata" className="w-full h-auto" data-testid="tutorial-video" poster="/screens/board.jpg"
          onPlay={() => { if (!window.__vidTracked) { window.__vidTracked = true; axios.post(`${API}/track/video-play`, { source: "tutorial" }).catch(() => {}); } }}>
          <source src="/videos/how-to-use.mp4" type="video/mp4" />
          Your browser does not support video playback.
        </video>
      </div>
      <div className="mt-5 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h3 className="font-semibold flex items-center gap-2"><PlayCircle className="h-4 w-4 text-primary" />Opero Smart in 60 seconds</h3>
          <p className="text-sm text-muted-foreground mt-1">Creating tasks, team chat, dashboards, timeline and calendar — the full workflow tour.</p>
        </div>
        <a href="/videos/how-to-use.mp4" download="opero-smart-tour.mp4">
          <Button variant="outline" size="sm" data-testid="tutorial-download-btn"><Download className="h-4 w-4 mr-1.5" />Download video</Button>
        </a>
      </div>
      <div className="mt-6 grid sm:grid-cols-4 gap-3">
        {[
          ["0:03", "Create & assign a task"],
          ["0:23", "Send a team chat message"],
          ["0:37", "Dashboard analytics"],
          ["0:47", "Timeline & calendar"],
        ].map(([t, label]) => (
          <div key={t} className="bg-card border rounded-xl p-3 text-center">
            <div className="text-xs font-mono text-primary font-semibold">{t}</div>
            <div className="text-xs text-muted-foreground mt-1">{label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
